function bindCalendarEventDayClick() {
  Array.from(document.getElementsByClassName('day--single-day-event')).forEach((elem) =>
    elem.addEventListener('click', function (e) {
      e.preventDefault();
      Array.from(document.getElementsByClassName('day--active')).forEach((el) => el.classList.remove('day--active'));

      elem.parentElement.classList.add('day--active');

      const selectedDate = elem.dataset.date; // Expects YYYY-MM-DD format from calendar day click

      let dynamicTabLinkId = 'tab-dynamic-day';
      let dynamicTabContentId = 'tab-dynamic-day';
      let sourceContainerId = 'dynamic-day-content-source';

      // Check if we are in the 'non-current month' context by looking for its specific source container
      if (document.getElementById('dynamic-day-content-source-non-current')) {
        dynamicTabLinkId = 'tab-dynamic-day-non-current';
        dynamicTabContentId = 'tab-dynamic-day-non-current';
        sourceContainerId = 'dynamic-day-content-source-non-current';
      }

      const dynamicTabLink = document.querySelector(`a[href="#${dynamicTabLinkId}"][data-dynamic-date-display]`);
      if (dynamicTabLink) {
        const displayDate = new Date(selectedDate + 'T00:00:00Z'); // Use ISO format with Z for UTC to avoid timezone issues
        const options = { day: 'numeric', month: 'long', timeZone: 'UTC' }; // Specify UTC
        dynamicTabLink.textContent = displayDate.toLocaleDateString(document.documentElement.lang || 'cs-CZ', options);
      }

      const dynamicTabContent = document.getElementById(dynamicTabContentId);
      if (!dynamicTabContent) return;

      dynamicTabContent.innerHTML = '';

      const sourceContainer = document.getElementById(sourceContainerId);
      if (!sourceContainer) return;

      // Find the group of events for the selected date
      const eventGroupForDate = sourceContainer.querySelector(`.event-group-for-date[data-event-date="${selectedDate}"]`);

      if (eventGroupForDate) {
        // Clone each event item from the found group
        const eventItems = eventGroupForDate.querySelectorAll('.event-item-source');
        if (eventItems.length > 0) {
          eventItems.forEach((eventNode) => {
            const clonedNode = eventNode.cloneNode(true);
            dynamicTabContent.appendChild(clonedNode);
          });
        } else {
          dynamicTabContent.innerHTML = `<p>${
            window.i18n && window.i18n['calendar.noEventsForThisDay']
              ? window.i18n['calendar.noEventsForThisDay']
              : 'Pro tento den nebyly nalezeny žádné události.'
          }</p>`;
        }
      } else {
        dynamicTabContent.innerHTML = `<p>${
          window.i18n && window.i18n['calendar.noEventsForThisDay']
            ? window.i18n['calendar.noEventsForThisDay']
            : 'Pro tento den nebyly nalezeny žádné události.'
        }</p>`;
      }

      toggleTab(`#${dynamicTabLinkId}`);
    })
  );
}

function updateEventCalendarOnTabChange(tabName) {
  const eventsTabTypes = Object.freeze({
    TODAY: 'TODAY',
    TOMORROW: 'TOMORROW',
    WEEK: 'WEEK',
    MONTH: 'MONTH',
    LAST: 'LAST',
    CHOSEN_DAY: 'CHOSEN_DAY',
  });

  const isDynamicDayTab =
    tabName === 'tab-dynamic-day' ||
    tabName === 'tab-dynamic-day-non-current' ||
    (tabName.startsWith('#tab-day-') && tabName !== '#tab-day-');

  if (tabName != 'tab-dynamic-day' && tabName != 'tab-dynamic-day-non-current' && !tabName.startsWith('tab-day')) {
    Array.from(document.querySelectorAll('a[href*="#tab-day-"]')).forEach((e) => e.classList.add('is-hidden'));
    // Hide both potential dynamic tab links
    const dynamicTabLinkCurrent = document.querySelector('a[href="#tab-dynamic-day"]');
    if (dynamicTabLinkCurrent) dynamicTabLinkCurrent.classList.add('is-hidden');
    const dynamicTabLinkNonCurrent = document.querySelector('a[href="#tab-dynamic-day-non-current"]');
    if (dynamicTabLinkNonCurrent) dynamicTabLinkNonCurrent.classList.add('is-hidden');
  }

  let effectiveTabName = tabName;
  if (isDynamicDayTab) {
    // Normalize to a common base if needed, or handle specific IDs if behavior differs significantly
    // For now, let's assume 'tab-dynamic-day' is the key for CHOSEN_DAY type,
    // but the actual tab ID (tabName) will be used for toggling.
    effectiveTabName = tabName.includes('non-current') ? 'tab-dynamic-day-non-current' : 'tab-dynamic-day';
  }

  const calendarTypeByTabName =
    {
      'tab-dnes': eventsTabTypes.TODAY,
      'tab-zitra': eventsTabTypes.TOMORROW,
      'tab-tento-tyden': eventsTabTypes.WEEK,
      'tab-tento-mesic': eventsTabTypes.MONTH,
      'tab-probehlo': eventsTabTypes.LAST,
      'tab-dynamic-day': eventsTabTypes.CHOSEN_DAY,
      'tab-dynamic-day-non-current': eventsTabTypes.CHOSEN_DAY,
      'tab-all-events-non-current': eventsTabTypes.MONTH,
    }[effectiveTabName.startsWith('#') ? effectiveTabName.substring(1) : effectiveTabName] ?? eventsTabTypes.WEEK;

  const calendar = document.getElementsByClassName('calendar')[0];
  if (!calendar) return;

  const calendarOldMode = [...calendar.classList].find((cls) => cls.startsWith('calendar--mode-'));
  const calendarNewModeBase = {
    [eventsTabTypes.TODAY]: 'today',
    [eventsTabTypes.TOMORROW]: 'tomorrow',
    [eventsTabTypes.WEEK]: 'week',
    [eventsTabTypes.MONTH]: 'month',
    [eventsTabTypes.LAST]: 'inactive',
    [eventsTabTypes.CHOSEN_DAY]: 'day',
  }[calendarTypeByTabName];

  const calendarNewMode = `calendar--mode-${calendarNewModeBase}`;

  if (calendarOldMode) {
    if (calendarOldMode !== calendarNewMode) {
      calendar.classList.replace(calendarOldMode, calendarNewMode);
    }
  } else {
    calendar.classList.add(calendarNewMode);
  }
}

function toggleTab(tabName) {
  const currentTabLink = document.querySelector('.tab-nav .js-tab-open.is-active');
  const currentTabName = currentTabLink ? currentTabLink.getAttribute('href') : '';

  if (currentTabName === tabName) return;

  if (currentTabLink) {
    currentTabLink.classList.remove('is-active');
    const mainStaticTabs = [
      '#tab-dnes',
      '#tab-zitra',
      '#tab-tento-tyden',
      '#tab-tento-mesic',
      '#tab-probehlo',
      '#tab-all-events-non-current',
    ];
    // If the current active tab is one of the dynamic day tabs, hide it.
    if (currentTabName === '#tab-dynamic-day' || currentTabName === '#tab-dynamic-day-non-current') {
      currentTabLink.classList.add('is-hidden');
    } else if (!mainStaticTabs.includes(currentTabName)) {
      currentTabLink.classList.add('is-hidden');
    }
  }

  document.querySelectorAll('.tab-content.is-open').forEach(function (element) {
    element.classList.remove('is-open');
  });

  const newTabLink = document.querySelector(`.tab-nav a.js-tab-open[href='${tabName}']`);
  if (newTabLink) {
    newTabLink.classList.remove('is-hidden');
    newTabLink.classList.add('is-active');
  }

  const newTabContentId = tabName.substring(1);
  const newTabContent = document.getElementById(newTabContentId);
  if (newTabContent) {
    newTabContent.classList.add('is-open');
  }

  if (window.tabSettings && typeof window.tabSettings.name === 'function') {
    window.tabSettings.name = newTabContentId;
  } else if (window.tabSettings) {
    window.tabSettings.name = newTabContentId;
  }

  updateEventCalendarOnTabChange(newTabContentId);
  return newTabLink;
}

function bindEventsPageListenersAfterUpdate() {
  if (typeof tab === 'function') {
    tab(updateEventCalendarOnTabChange);
  } else {
    document.querySelectorAll('.tab-nav a.js-tab-open:not([data-dynamic-date-display])').forEach((mainTabLink) => {
      mainTabLink.addEventListener('click', function (event) {
        event.preventDefault();
        toggleTab(this.getAttribute('href'));
      });
    });
  }
  bindCalendarEventDayClick();
  share();
}

function filterEvents() {
  const recaptcha = document.querySelector('.g-recaptcha');
  const form = document.getElementById('search-form-event');

  if (recaptcha) {
    if (grecaptcha.getResponse()) {
      return;
    } else {
      form.submit();
    }
  }

  const eventPage = document.querySelector('.events-page');
  const loading = eventPage.querySelector('.spinner__wrap');
  loading.classList.remove('is-hidden');

  const searchParams = new URLSearchParams(window.location.search);

  fetch(
    window.location.pathname +
      '?' +
      new URLSearchParams({
        'event_search_form[search]': searchParams.get('event_search_form[search]'),
        'category.id': searchParams.get('category'),
      }).toString(),
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
    }
  )
    .then((response) => response.text())
    .then((data) => {
      const doc = new DOMParser().parseFromString(data, 'text/html');
      if (!doc) return;

      const calendar = doc.getElementsByClassName('calendar')[0];
      const tab = doc.getElementsByClassName('tab')[0];
      const recaptcha = doc.querySelector('.g-recaptcha');

      if (!calendar || !tab) return;

      const oldTab = document.getElementsByClassName('tab')[0];
      const oldSearch = eventPage.querySelector('.search');
      const oldRecaptcha = oldSearch.querySelector('.g-recaptcha');

      if (recaptcha && !oldRecaptcha && form) {
        form.submit();
      } else if (oldRecaptcha) {
        oldRecaptcha.remove();
      }

      document.getElementsByClassName('calendar')[0].replaceWith(calendar);

      if (tab && oldTab) oldTab.replaceWith(tab);

      bindEventsPageListenersAfterUpdate();

      const oldTabActive = oldTab.getElementsByClassName('is-active')[0];
      const tabName = oldTabActive ? oldTabActive.getAttribute('href') : null;
      if (tabName) toggleTab(tabName);

      loading.classList.add('is-hidden');
    })
    .catch((error) => {
      console.error('Error:', error);

      loading.classList.add('is-hidden');
    });
}

function bindSearchEventsListener() {
  document.getElementById('search-btn-events').addEventListener('click', function (e) {
    e.stopImmediatePropagation();
    e.preventDefault();
    updateUrlSearchParam();
    filterEvents();
  });
  document.getElementById('search-input-events').addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.stopImmediatePropagation();
      e.preventDefault();
      updateUrlSearchParam();
      filterEvents();
    }
  });
}

function updateUrlSearchParam() {
  const search = document.getElementById('search-input-events').value;

  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set('event_search_form[search]', search);
  window.history.replaceState(null, '', window.location.pathname + '?' + searchParams.toString());
}

function bindEventCategoryChange() {
  const categorySelect = document.querySelector('[name="event-categories"]');
  if (!categorySelect) return;

  categorySelect.addEventListener('change', (e) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('category', e.target.value);
    window.history.replaceState(null, '', window.location.pathname + '?' + searchParams.toString());

    filterEvents();
  });
}
